<template>
  <div class="wrapper layout-login">
    <notifications></notifications>

    <div class="main-content d-flex flex-column">
      <div class="m-auto">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view class="main-content-view"></router-view>
        </fade-transition>
      </div>
      <content-footer
        class="mt-auto"
        v-if="!$route.meta.hideFooter"
      ></content-footer>
    </div>
  </div>
</template>
<script>
import ContentFooter from "./Default/ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    ContentFooter,
    FadeTransition,
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="scss"></style>
